export default "/images/7ab8ed1316566bbca6d1e07e52c7b6f3.png";